@if (showBtn) {
<button type="button"
        class="btn btn-checklist"
        (click)="toggle()"
        title="Checksheet control"
        aria-label="Checksheet control">
</button>
}